import * as React from 'react';
import { ReactComponent } from '../../utils/react_helpers';

interface IProps {
  style?: React.CSSProperties;
  className?: string;
}

export type IconType = ReactComponent<{ iconClassName?: string; style?: React.CSSProperties }>;

// eslint-disable-next-line react/display-name
export const createIcon = (children: React.ReactNode | string): React.SFC<IProps> => ({ style, className }: IProps) => {
  if (typeof children === 'string') {
    return <span style={style} className={className} dangerouslySetInnerHTML={{ __html: children }} />;
  }

  return (
    <span style={style} className={className}>
      {children}
    </span>
  );
};
